import {Component, OnInit} from '@angular/core';
import {MatAnchor} from '@angular/material/button';
import {MatCard, MatCardContent} from '@angular/material/card';
import {RouterLink} from '@angular/router';

@Component({
    selector: 'frog-upgrade-card',
    templateUrl: './upgrade-card.component.html',
    styleUrls: ['./upgrade-card.component.scss'],
    imports: [MatCard, MatCardContent, MatAnchor, RouterLink],
})
export class UpgradeCardComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    upgrade() {}
}
